module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "编辑订单"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.formData,
      "rules": _vm.formRule
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "contractName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.formData.contractName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractName", $$v)
      },
      expression: "formData.contractName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "监护人",
      "prop": "guardian"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.formData.guardian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "guardian", $$v)
      },
      expression: "formData.guardian"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onInsert
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27cd010d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/EditOrderModal.vue
// module id = 1693
// module chunks = 8